import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReportIcon(props: IconProps) {
    return <Icon {...props} iconKey={"report"}/>
}
